// @ts-strict-ignore
import React, { Dispatch, useEffect } from 'react'
import { usePaginationWithApi } from './usePaginationWithApi'

interface UseApiPaginationWithPaymentsListProps {
  onPageChange: (params: { paging: { offset: number } }) => void
  setPaymentsList: Dispatch<React.SetStateAction<any>>
  executor: () => void
  pagingMax: number
}

export const useApiPaginationWithPaymentsList = ({
  onPageChange,
  setPaymentsList,
  executor,
  pagingMax,
}: UseApiPaginationWithPaymentsListProps) => {
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePaginationWithApi({
    onPageChangeApi: onPageChange,
    onRowsPerPageChangeApi: ({ paging: newPaging, pagingMax: newPagingMax }) => {
      setPaymentsList(prev => ({
        ...prev,
        paging: { ...prev.paging, ...newPaging },
        pagingMax: newPagingMax,
      }))
    },
    executeQuery: executor,
  })

  useEffect(() => {
    if (pagingMax === 20 && rowsPerPage !== 20) {
      handleChangeRowsPerPage(20)
    }
  }, [pagingMax, rowsPerPage, handleChangeRowsPerPage])

  return {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  }
}
